import React from 'react';
import { connect } from 'react-redux';
import ItemTrackingNumbersPopup from '../../components/popups/item-tracking-numbers-popup';
function ItemTrackingNumbersContainer({
  ksTrackings,
  orderNumber,
  onClose
}) {
  return /*#__PURE__*/React.createElement(ItemTrackingNumbersPopup, {
    onClose: onClose,
    ksTrackings: ksTrackings,
    orderNumber: orderNumber
  });
}
const selector = state => ({
  ksTrackings: state.accountOrders.showingTrackingNumbers.ksTrackings,
  orderNumber: state.accountOrders.showingTrackingNumbers.orderNumber
});
export default connect(selector)(ItemTrackingNumbersContainer);